import * as homeApi from '@/network/api/home.api.js'
import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as accountApi from '@/network/api/accounts.api.js'
import * as operationsApi from '@/network/api/operations/operations.api.js'
import * as signedApi from '@/network/api/operations/signed.api.js'
import * as smartTransfersApi from '@/network/api/smartTransfers.api.js'
import * as beneficiariesApi from '@/network/api/transfers/beneficiaries.api.js'
import * as exchangeApi from '@/network/api/exchange.api.js'
import * as mobilePaymentsApi from '@/network/api/mobilePayments.api.js'
import * as tpaRequestApi from '@/network/api/tpaRequest.api.js'
import * as operatorsApi from '@/network/api/operators.api.js'
import * as frequentsApi from '@/network/api/frequents.api.js'
import * as transfersApi from '@/network/api/transfers/transfers.api.js'
import * as paymentsApi from '@/network/api/payments/payments.api.js'
import * as cardlesswithdrawalApi from '@/network/api/cardlesswithdrawal.api.js'
import * as internationalTransfers from '@/network/api/internationalTransfers.api.js'

/** requests exchange table with value
@return { promise } - Exchange table with value request
*/
export const requestedSignListCounter = async (context, payload) => {
    const res = await signedApi.getOperationApprovalsList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_APPROVALS_TO_SIGN_NUMBER', data)
    }
    return res
}

/** requests Home Patrimony Data
@return {promise} - Home Patrimony request
*/
export const fetchHomePatrimony = async (context, payload) => {
    const res = await homeApi.requestHomePatrimony(payload)
    if (res) {
        const data = res.data.data
        context.commit('UPDATE_HOME_PATRIMONY_INFO', data)
    }
    return res
}

/** requests merchant creatian status
@return { promise } - merchant creatian status response
*/
export const fetchMerchantStatus = async (context, payload) => {
    const res = await mobilePaymentsApi.validateMobileMerchantStatus()
    return res
}

/** requests Cards List for widget
@return {promise} - Home Patrimony request
*/
export const requestCardsList = async (context, payload) => {
    const res = await cardsApi.cards(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_CARDS_LIST', data)
    }
    return res
}

/** requests Accounts List for widget
@return {promise} - accounts balances list request
*/
export const requestAccountsList = async (context, payload) => {
    const res = await accountApi.requestAccountsBalances()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_LIST', data)
    }
    return res
}

/** requests last naHora transfers List for widget
@return {promise} - last naHora transfers list request
*/
export const requestLastNaHoraTransfers = async (context, payload) => {
    const res = await operationsApi.getOperationHistoryList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_LAST_NA_HORA_TRANSFERS_LIST', data)
    }
    return res
}

/** submit Smart Transfer
@return { promise }
*/
export const createSmartTransfer = async (context, payload) => {
    const res = await smartTransfersApi.createSmartTransferSendMoney(payload)
    return res
}

/** request Beneficiary Destination Info
@return {promise} - Beneficiary Destination Info
*/
export const requestBeneficiaryName = async (context, payload) => {
    const res = await beneficiariesApi.getBeneficiaryName(payload)

    return res
}

/** requests Cashflow Info
@return {promise} - Cashflow info response
*/
export const requestCashflowInfo = async (context, payload) => {
    const res = await accountApi.requestCashflowInfo(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_CASHFLOW_INFO', data)
    }
}

/** requests Home Movements Data
@return {promise} - Home Movements request
*/
export const requestAccountsMovements = async (context, payload) => {
    const res = await accountApi.requestAccountsMovements(payload)
    if (res) {
        const data = res.data.data
		context.commit('SAVE_HOME_MOVEMENTS', data.movements)
    }
    return res
}

/** requests exchange table list
@return { promise } - Exchange table request
*/
export const requestExchangeTableList = async (context, payload) => {
    const res = await exchangeApi.requestExchangeTableList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_EXCHANGE_TABLE_LIST', data)
    }
    return res
}

/** requests exchange table with value
@return { promise } - Exchange table with value request
*/
export const requestExchangeTableWithValue = async (context, payload) => {
    const res = await exchangeApi.requestExchangeTableWithValue(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_EXCHANGE_TABLE_WITH_VALUE', data)
    }
    return res
}

/** requests Dashboard Cards
@return {promise} - Dashboard Cards request
*/
export const fetchDashboardCards = async (context, payload) => {
    const res = await homeApi.requestDashboardCards(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_DASHBOARD_CARDS', data.dashboardCards)
    }
    return res
}

/** requests tpas list
@return { promise } - tpas list response
*/
export const requestTPAsList = async (context, payload) => {
    const res = await tpaRequestApi.getListTPAsRequested(payload)
    if (res) {
        const data = res.data.data.list
        context.commit('SAVE_TPAS_LIST', data)
    }
    return res
}

/** requests operators list
@return { promise } - operators list response
*/
export const requestOperatorsList = async (context, payload) => {
    const res = await operatorsApi.getOperatorsList()
    if (res) context.commit('SAVE_OPERATORS_LIST', res.data.data.list)
    return res
}

/** requests frequent operations
@return { promise } - frequent operations response
*/
export const requestFrequentOperations = async (context, payload) => {
    const res = await frequentsApi.getFrequentOperations(payload)
    if (res) context.commit('SAVE_FREQUENT_OPERATIONS', res.data.cards)
    return res
}

/** requests transfers detail
@return { promise } - transfers detail
*/
export const requestTransfersDetail = async (context, payload) => {
    const res = await transfersApi.getTransfersDetails(payload)
    return res
}

/** requests smart transfers detail
@return { promise } - smart transfers detail
*/
export const requestSmartTransfersDetail = async (context, payload) => {
    const res = await operationsApi.getSmartTransfersDetails(payload)
    return res
}

/** requests Payment Detail
@return { promise } -  payment detail detail
*/
export const requestPaymentsDetail = async (context, payload) => {
    const res = await paymentsApi.getPaymentDetail(payload)
    return res
}

/** requests cardless withdraw detail
@return { promise } - cardless withdraw detail
*/
export const requestCardlessWithdrawDetail = async (context, payload) => {
    const res = await cardlesswithdrawalApi.requestCardlessWidthdrawCodeDetail(payload)
    return res
}

/** requests international transfer detail
@return { promise } - international transfer detail
*/
export const requestInternationalTransferDetail = async (context, payload) => {
    const res = await internationalTransfers.requestTransferDetail(payload)
    return res
}

/** requests topups transfer detail
@return { promise } - topups transfer detail
*/
export const requestTopupsTransferDetail = async (context, payload) => {
    const res = await cardsApi.getTopupsTransferDetails(payload)
    return res
}

/** requests mobile payment detail
@return { promise } - mobile payment detail
*/
export const requestMobilePaymentDetail = async (context, payload) => {
    const res = await mobilePaymentsApi.getMobilePaymentDetail(payload)
    return res
}
/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
